<template>
    <button
        class="tiptap-btn"
        type="button"
        :title="$t('Bulleted list')"
        :disabled="disabled"
        :class="{ 'is-active': editor.isActive('bulletList') }"
        @click="editor.chain().focus().toggleBulletList().run()">
        <FormatListBulletedIcon size="16"/>
    </button>
</template>

<script>
import FormatListBulletedIcon from '@/common/components/svg-icons/FormatListBulletedIcon.vue';
import {Editor} from '@tiptap/vue-2';

export default {
    name: 'MenuBarBulletedListButton',

    props: {
        editor: {
            type: Editor,
            required: true
        },
        disabled: {
            type: Boolean,
            default: false
        }
    },

    components: {
        FormatListBulletedIcon
    }
};
</script>
